import api from '../common/api'
const reducer = (state, action) => {
    switch (action.type) {
        case 'setProfile':
            if (action.user) {
                const normalizedUser = {
                    ...action.user,
                    farmData: action.user.farmData || action.user.farms || []
                };
                window.localStorage.setItem('profile', JSON.stringify(normalizedUser));
                window.localStorage.setItem('token', normalizedUser.token);
                return {
                    ...state,
                    ...normalizedUser,
                    isLoggedIn: (normalizedUser.token && normalizedUser.token.length > 0)
                };
            } else {
                return state;
            }
        case 'logout':
            api.post('sign-out',JSON.parse(localStorage.getItem("profile")))
            .then((res)=>{
                console.log(res);
                handleSignOut();       
            }).catch((err)=>{
                console.log(err);
                handleSignOut();
            })
            return {
                ...state,
                isLoggedIn: false
            };
        case 'config':
            let newState = state
            newState.Config[action.payload.name]=!action.payload.value;
            window.localStorage.setItem('profile', JSON.stringify(newState));
            return {
                ...newState
        };
        case 'setTempVersion':
            if (action.user) {
                return {
                    ...state,
                    ...action.user
                };
            }
            else {
                return state;
            }
        default:
            return state;
    }
};

export default reducer;

function handleSignOut() {
    window.localStorage.setItem('profile', '');
    window.localStorage.setItem('token', '');
    window.localStorage.removeItem('taxData')   
}